import Banner from "~/components/banner"
import MarkdownArticle from "~/components/markdownArticle"
import { readFileSync } from "fs"

const article = readFileSync(__dirname + "/article.md", "utf-8")

export default class ModelOrganism extends Component {
  render() {
    return (
      <React.Fragment>
        <Banner
          noFigure
          title="The Importance of Model Organisms in Interpretability"
        />
        <MarkdownArticle src={article} />
      </React.Fragment>
    )
  }
}
